import type { ComponentProps } from 'react';

import { FindyLogoLink } from '../../../components/findy-logo-link.component';
import { HamburgerMenu } from '../../../components/hamburger-menu/hamburger-menu.component';
import { MainHamburgerMenuList } from './main-hamburger-menu-list.component';
import styles from './main-mobile-content.component.module.scss';
import { NotificationLink } from './notification-link.component';

type Props = ComponentProps<typeof NotificationLink> &
  ComponentProps<typeof MainHamburgerMenuList>;

export const MainMobileContent = ({
  children: CareerMotivationButton,
  unreadCount,
  isFreelanceUser,
  isTargetUser,
  pathname,
  profileCompletionProgress,
  unreadMessageCount,
  onLogout,
}: Props) => {
  return (
    <div className={styles.mobileLoginContent}>
      <HamburgerMenu>
        <MainHamburgerMenuList
          isFreelanceUser={isFreelanceUser}
          isTargetUser={isTargetUser}
          pathname={pathname}
          profileCompletionProgress={profileCompletionProgress}
          unreadMessageCount={unreadMessageCount}
          onLogout={onLogout}
        >
          {CareerMotivationButton}
        </MainHamburgerMenuList>
      </HamburgerMenu>
      <FindyLogoLink align="center" />
      <NotificationLink unreadCount={unreadCount} />
    </div>
  );
};
